import './lang-observer';
import './layout-sdo';
import './init-router-service';
import './route-view-element';
import './site-header';
import './site-navigation';
import './impersonating-banner';
import './site-footer';
import './left-panel';
import './pdf-template';
import './__config/modals';
import {environment} from './constants-enumerate';
import * as Sentry from '@sentry/browser';
import {initConfig} from './__config/sentry-config';

Sentry.init(initConfig);

if ((environment.DEV || environment.STAGE || environment.DEV_BUILD) && typeof window.aoflDevtools === 'undefined') {
  window.aoflDevtools = {
    // showI18nIds: true
  };
}

/* istanbul ignore next */
if (
  location.protocol === 'https:' &&
  environment.PROD_BUILD &&
  'serviceWorker' in navigator &&
  typeof aofljsConfig.__prerender__ === 'undefined'
) {
  navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js', { // eslint-disable-line
    scope: __webpack_public_path__
  });
}
